module.exports = __webpack_public_path__ + "media/newstyle/images/visa-7b8b40aa41e23f9a69391704c6523fa8.svg";